export default __webpack_public_path__ + "static/media/jyxz.89c6a671.jpg";